class Modify_Number {
    static path = 'modifiers/modify-number';

    constructor(mutator){
        this.bgcolor = '#ea93f8';
        this.title = 'Modify Number';
        this.desc = 'Perform simple mathematics on two numbers';
        this.values = ["+", "-", "x", "÷", "^", "%"];
        this.properties = {value: '+'}

        this.addInput("A", "number");
        this.addInput("B", "number");
        this.addOutput("Result", "number");
        this.addWidget("combo","",'+',{ property: "value", values: this.values } );
    }

    getTitle() {
        return "A " + this.properties.value + " B";
    }

}

module.exports = Modify_Number
